import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Dashboard } from '../../../../../utils/string'
import ContactUs from '../../../../modals/ContactUs'
import BrandLogo from '../../../../../_supplier/assets/media/uProcureLogo.png'
import { useAuth } from '../../core/Auth'
import { Button } from 'react-bootstrap'
const KycRejected = () => { 
  const [message, setMessage] = useState('')
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const sendFeedback = async () => {
    setLoading(true)
    setMessage('')
    setShow(false)
    setLoading(false)
  }
  const handleMessage = (value: string) => {
    setMessage(value)
  }
  const { logout } = useAuth()
  const [logoutLoading, setLogoutLoading] = useState(false)
  const handleLogout = async () => {
    logout()
    setLogoutLoading(false)
  }
  return (
    <>
      <div className='d-flex flex-column flex-row-fluid py-10'>
        <div className='px-md-15 px-8'>
          <Link to='/' className='mb-12 position-absolute top-0 start-0 mt-10 ms-10'>
            <img alt='Logo' src={BrandLogo} className='h-40px' />
          </Link>
          <span className='btn btn-lg p-6 position-absolute top-0 end-0 mt-10 me-10' onClick={handleLogout} style={{color:'#7C7C7C'}}>
            <span className='indicator-label fs-16'>Logout</span>
            {logoutLoading ? (
              <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              <></>
            )}
          </span>
        </div>
        <div className='px-md-15 px-8'>
          <div className='flex-end'>
            <Link to='/' className='mb-12 position-absolute top-0 start-0 mt-10 ms-10'>
              <img alt='Logo' src={BrandLogo} className='h-40px' />
            </Link>
          </div>
        </div>
        <div className='d-flex flex-center flex-column flex-column-fluid pt-lg-0 pt-15'>
          <div className='d-flex justify-content-center align-items-center bg-light-danger p-3 px-4 pills-radius'>
            <span className='bullet bullet-dot bg-danger me-2 h-10px w-10px'></span>
            <span className='fw-600 text-black fs-18'>{Dashboard.detailsRejected}</span>
          </div>
          <div className='text-center '>
            <div className='w-lg-650px py-7'>
              <h1 className='text-dark fs-36 fw-700'>
                {Dashboard.welcome}
                Growspace Private Limited
              </h1>
              <p className='fs-20 fw-500 mb-0 pt-5'>
                {Dashboard.incorrectDocuments}
              We identified that your seller account doesn’t comply with our terms and conditions. If you have any queries, please contact us.
              </p>
            </div>
          </div>
          <div className='text-center'>
            <ContactUs
              handleClose={handleClose}
              show={show}
              handleShow={handleShow}
              sendFeedback={sendFeedback}
              handleMessage={(value: string) => {
                handleMessage(value)
              }}
              message={message}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </>
  )
}
// export {kycRejected}
export default KycRejected
